import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentHistory = () => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "null");

  const historyKey = user?.email
    ? `payment_history_${user.email}`
    : "payment_history_guest";

  const history = JSON.parse(localStorage.getItem(historyKey)) || [];

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Payment History</h1>

          <button
            onClick={() => navigate("/")}
            style={styles.backBtn}
          >
            Back Home
          </button>
        </div>

        {history.length === 0 ? (
          <div style={styles.emptyBox}>
            <h2>No Payment History Found</h2>

            <p>
              Your Plan, Puja, Astrologer and Consultation
              payments will appear here.
            </p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Order ID</th>
                  <th style={styles.th}>Title</th>
                  <th style={styles.th}>Type</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Payment</th>
                  <th style={styles.th}>Status</th>
                  <th style={styles.th}>Date</th>
                </tr>
              </thead>

              <tbody>
                {history.map((item, index) => (
                  <tr key={index} style={styles.tr}>
                    <td style={styles.td}>{item.order_id}</td>

                    <td style={styles.td}>
                      {item.title}
                    </td>

                    <td style={styles.td}>
                      <span style={styles.typeBadge}>
                        {item.type}
                      </span>
                    </td>

                    <td style={styles.td}>
                      ₹{item.amount}
                    </td>

                    <td style={styles.td}>
                      {item.payment_mode}
                    </td>

                    <td style={styles.td}>
                      <span style={styles.successBadge}>
                        {item.payment_status}
                      </span>
                    </td>

                    <td style={styles.td}>
                      {item.date
                        ? new Date(item.date).toLocaleString()
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    padding: "30px 14px",
    background:
      "linear-gradient(180deg,#faf7ff 0%,#ffffff 100%)",
    fontFamily: "Arial",
  },

  container: {
    maxWidth: "1300px",
    margin: "0 auto",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    marginBottom: "24px",
    flexWrap: "wrap",
  },

  title: {
    margin: 0,
    fontSize: "36px",
    fontWeight: "900",
    color: "#4c1d95",
  },

  backBtn: {
    border: "none",
    borderRadius: "999px",
    padding: "12px 24px",
    background: "#7c3aed",
    color: "#fff",
    fontWeight: "800",
    cursor: "pointer",
  },

  tableWrapper: {
    overflowX: "auto",
    background: "#fff",
    borderRadius: "24px",
    boxShadow: "0 18px 45px rgba(15,23,42,.08)",
    border: "1px solid #ede9fe",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1000px",
  },

  th: {
    background: "#f5f3ff",
    padding: "18px",
    textAlign: "left",
    color: "#4c1d95",
    fontWeight: "800",
    fontSize: "15px",
    borderBottom: "1px solid #ede9fe",
  },

  tr: {
    transition: ".3s",
  },

  td: {
    padding: "18px",
    borderBottom: "1px solid #f3f4f6",
    color: "#374151",
    fontSize: "14px",
    verticalAlign: "middle",
  },

  typeBadge: {
    background: "#ede9fe",
    color: "#6d28d9",
    padding: "7px 12px",
    borderRadius: "999px",
    fontWeight: "700",
    fontSize: "12px",
    textTransform: "capitalize",
  },

  successBadge: {
    background: "#dcfce7",
    color: "#166534",
    padding: "7px 12px",
    borderRadius: "999px",
    fontWeight: "700",
    fontSize: "12px",
    textTransform: "capitalize",
  },

  emptyBox: {
    background: "#fff",
    borderRadius: "24px",
    padding: "50px 20px",
    textAlign: "center",
    boxShadow: "0 18px 45px rgba(15,23,42,.08)",
  },
};

export default PaymentHistory;